import { Theme, layers, styled, Colors } from '@unfold/theme';

export const ModalContainer = styled.div`
  height: 100vh;
  left: 0px;
  overflow-y: auto;
  position: absolute;
  top: 0px;
  width: 100%;
  z-index: ${layers.dialog};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Overlay = styled.div`
  height: 100vh;
  left: 0;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${layers.dialog()};
  background-color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.G100 : Colors.G100};
  -webkit-overflow-scrolling: touch;
  opacity: ${({ theme }): number => (theme?.name === Theme.LIGHT ? 0.3 : 0.7)};
`;
